/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscriptions.js                                                                */
/**********************************************************************************************************************/
/* subscriptions */
HafasWebapp.prototype.subscriptions = {};


HafasWebapp.prototype.subscriptions.app = function (_me) {
  // switch Application Context
  Hafas.ps.sub('/app/switchContext', Hafas.bind(_me.Controller.App.switchContext, _me));


  // switch Language
  Hafas.ps.sub('/app/switchLanguage', Hafas.bind(_me.Controller.App.switchLanguage, _me));

  // Initialize automatic reload
  Hafas.ps.sub('/app/initReload', Hafas.bind(_me.Controller.App.initReload, _me));

  // resize ResultContainer if necessary
  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.GUI.resize, _me));
  if (Hafas.Config.Switches.useMap) {
    //Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.Map.updateOffset, _me));
    //Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.Map.updateSize, _me));
  }

  // events controlling resultcontainer
  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.App.events.closeResults, _me));
};

HafasWebapp.prototype.subscriptions.common = function (_me) {
  // Common-Events -------------------------------------------------------------------------------------------------
  // getActualPosition
  Hafas.ps.sub('/common/getActualPosition', Hafas.bind(_me.Controller.Common.getActualPosition, _me));
  Hafas.ps.sub('/util/getCurrentPosition', Hafas.bind(_me.Controller.Common.setHCIClientPositionInfo, _me));
  Hafas.ps.sub('/util/errGetCurrentPosition', Hafas.bind(_me.Controller.Common.clearHCIClientPositionInfo, _me));

  // Interne Links öffnen
  Hafas.ps.sub('/common/open/internal', Hafas.bind(_me.Controller.Common.openInternalWebAppContext, _me));

  // Externe Links öffnen
  Hafas.ps.sub('/common/open/internal', Hafas.bind(_me.Controller.Common.openInternalWebAppContext, _me));

  // Interne Links öffnen
  Hafas.ps.sub('/common/openInternalLink', Hafas.bind(_me.Controller.Common.openInternalLink, _me));

  // Externe Links öffnen (Für Overlay gebraucht)
  Hafas.ps.sub('/common/openExternalLink', Hafas.bind(_me.Controller.Common.openExternalLink, _me));
  Hafas.ps.sub('/common/closeExternalLinkOverlay', Hafas.bind(_me.Controller.Common.closeExternalLinkOverlay,_me));

  // Öffnet einen External Content
  Hafas.ps.pub('/common/open/externalContent', Hafas.bind(_me.Controller.Common.openExternalContent,_me));

  // Open Tariff Lib
  Hafas.ps.sub('/common/openLibTariff', Hafas.bind(_me.Controller.Common.openLibTariff,_me));

 // Hafas.ps.sub('/common/observe/inputvalues', Hafas.bind(_me.Controller.Common.Observe.Inputs, _me));

  // Time & Date
  Hafas.ps.sub('/common/time/datepicker/open', Hafas.bind(_me.Controller.Common.Time.DatePicker.open, _me));
  Hafas.ps.sub('/common/time/datepicker/onShow', Hafas.bind(_me.Controller.Common.Time.DatePicker.onShow, _me));
  Hafas.ps.sub('/common/time/datepicker/onHide', Hafas.bind(_me.Controller.Common.Time.DatePicker.onHide, _me));
  Hafas.ps.sub('/common/time/datepicker/confirm', Hafas.bind(_me.Controller.Common.Time.DatePicker.confirm, _me));
  Hafas.ps.sub('/common/time/datepicker/cancel', Hafas.bind(_me.Controller.Common.Time.DatePicker.cancel, _me));
  Hafas.ps.sub('/common/time/datepicker/setData', Hafas.bind(_me.Controller.Common.Time.DatePicker.setData, _me));
  Hafas.ps.sub('/common/time/datepicker/onChangeOfNativeInput', Hafas.bind(_me.Controller.Common.Time.DatePicker.onChangeNativeInput, _me));
  Hafas.ps.sub('/renderer/renderDone', Hafas.bind(_me.Controller.App.events.renderDone, _me));
};


HafasWebapp.prototype.subscriptions.apis = function (_me) {
  // HTML5-API-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/apis/geolocation/check', Hafas.bind(_me.Controller.APIs.Geolocation.check, _me));
};


HafasWebapp.prototype.subscriptions.exceptions = function (_me) {
  // Error-Events -------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/exceptions/tq/getRoute', Hafas.bind(_me.Controller.Exceptions.TQ.getRoute, _me));
  Hafas.ps.sub('/exceptions/tq/drawHighlightedSection', Hafas.bind(_me.Controller.Exceptions.TQ.drawHighlightedSection, _me));
};

// TODO: Der Block gehört hier nicht her. Das sollte im TP stehen.
HafasWebapp.prototype.subscriptions.suggest = function (_me) {
// Suggest-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub("/suggest/selectitem/From", Hafas.bind(function (loc, suggest, isValidation) {

    isValidation = !!isValidation;
    _me.Controller.TP.instance.setLocation("dep", loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      _me.Controller.Favorites.instance.addLocation(loc, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('From');
    if (!isValidation && Hafas('#To') && Hafas('#To').value === "") {
      Hafas.Util.gui.focusElement(Hafas('#To'))
    }
    if (_me.Controller.TP.currentView === 'overview') {
      Hafas.ps.pub("/tp/events/trigger/unified");
    }
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'dep', className: 'js_highLightingError'} ]);


  }, _me));

  // Create via events dynamically if trip planner and vias are activated
  if(Hafas.Config.Switches.useTravelplanner && Hafas.Config.TP.vias.amount > 0) {
    for (var v = 0; v < Hafas.Config.TP.vias.amount; v++) {
      Hafas.ps.sub("/suggest/selectitem/HFS_Via" + v, Hafas.bind(function (vIdx) {
        return function (loc) {
          _me.Controller.TP.setVia.bind(_me)(vIdx, loc);
          // trigger search only if vias are set/editable in main input form,
          // otherwise vias are available in options and search will be triggered directly after clicking "save" in options
          if (_me.Controller.TP.currentView === 'overview' && Hafas.Config.TP.vias.showInForm === true) {
            Hafas.ps.pub('/tp/events/trigger/unified');
          }
          Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
        }
      }, _me)(v));
    }
  }


  Hafas.ps.sub("/suggest/selectitem/HFS_SQDirection", Hafas.bind(function (loc) {
    _me.Controller.SQ.options.setRandomParameter("HFS_SQDirection", "value", loc);
    Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: true}]);
  }, _me));

  Hafas.ps.sub("/suggest/selectitem/To", Hafas.bind(function (loc) {
    _me.Controller.TP.instance.setLocation("arr", loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      _me.Controller.Favorites.instance.addLocation(loc, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('To');
    if (_me.Controller.TP.currentView === 'overview') {
      Hafas.ps.pub("/tp/events/trigger/unified");
    }
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'arr', className: 'js_highLightingError'} ]);

  }, _me));
};


HafasWebapp.prototype.subscriptions.forms = function (_me) {
// Form-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/forms/reset', Hafas.bind(_me.Controller.Forms.reset, _me));
};


HafasWebapp.prototype.subscriptions.favorites = function (_me) {

  // Favorite Controller Events

  // Get list of favorite locations
  Hafas.ps.sub('/favorites/getLocationFavorites', Hafas.bind(function () {
    var data;
    if (Hafas.Config.Switches.useFavorites) {
      data = _me.Controller.Favorites.instance.getData();
    }
    return data ? data.locations : [];
  }, _me));

  // Location ausw�hlen
  Hafas.ps.sub('/favorites/setLocation', Hafas.bind(function (data) {
    var locData = Hafas.Modules.Render.objectKeeper.get(data.loc);
    var location = _me.Controller.Favorites.instance.getLocationById(locData.id, data.storage);

    // Tracking
    // Hier muss das Speicherobjekt der "location" untersucht werden, ob es sich um einen Favoriten oder nur um einen History-Eintrag
    // handelt.
    var lh = 0, lhLen = _me.Controller.Favorites.instance.data.locationsHistory.length;
    var _isLocHistory;
    // Wenn kein history-Eintrag vorhanden ist, kann es nur Favorit sein
    if (lhLen <= 0) {
      _isLocHistory = false;
    } else {
      // Prüfe die History-Einträge
      for (lh; lh < lhLen; lh++) {
        var _locEntry = _me.Controller.Favorites.instance.data.locationsHistory[lh];

        if (location.lid == _locEntry.lid) {
          _isLocHistory = true;
        }
      }
    }

    if (data.type == "dep") {
      _me.Controller.TP.instance.setLocation(data.type, location);
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-a', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "arr") {
      _me.Controller.TP.instance.setLocation(data.type, location);
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-b', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "via") {
      var viaIndex = _me.Controller.TP.instance.getAvailableViaIndex(); // Neuer Index = erster freier Via Platz
      if (viaIndex != -1) {
        Hafas.ps.pub('/tp/setVia', [viaIndex, location]);
      }
      if (Hafas.Config.TP.vias.showInForm && !_me.Controller.TP.viasOpen) {
        _me.Controller.TP.showViaForm.bind(_me)();
      }
      //Hafas.ps.pub('/tracking/event/favorites-locations-as-via', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == "station") {
      _me.Controller.SQ.instance.setLocation(location);

      if (typeof data.hitSearch !== "undefined") {
        if (data.hitSearch) {
          // Disable search button, when a location has been selected from the favorites
          if (document.form_stationsearch.elements.submitSQForm) {
            Hafas.bind(_me.Controller.App.triggerLoadingImage, this)(document.form_stationsearch.elements.submitSQForm);
          }
          Hafas.bind(_me.Controller.SQ.updateSearch,_me)();
        }
        Hafas.ps.pub('/sq/favorites/selectStopFromNearList/closePopover');
      } else {
        if (document.form_stationsearch.elements.submitSQForm) {
          Hafas.bind(_me.Controller.App.triggerLoadingImage, this)(document.form_stationsearch.elements.submitSQForm);
        }
        Hafas.bind(_me.Controller.SQ.updateSearch,_me)();
      }

      //Hafas.ps.pub('/tracking/event/favorites-locations-as-input', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == 'reachability') {
      // Disable search button, when a location has been selected from the favorites
      if (document.form_proximitysearch.elements.submitReachabilityForm) {
        Hafas.bind(_me.Controller.App.triggerLoadingImage, _me)(document.form_proximitysearch.elements.submitReachabilityForm);
        Hafas.bind(_me.Controller.Reachability.showInfiniteLoader, _me)();
      }
      Hafas.bind(_me.Controller.Reachability.hideResult, _me)();
      _me.Controller.Reachability.instance.startSearch(Hafas.bind(_me.Controller.Reachability.showResult, _me));

      _me.Controller.Reachability.instance.setLocation(location);
      Hafas.ps.pub('/tracking/event/favorites-locations-as-input', ['[' + _me.appContext + '] ' + location.lid]);
    } else if (data.type == 'timetable') {
      var locationName = Hafas.Util.getLocationAttribute(location, "name");
      var timetableInput = Hafas('#TimetableStopInput');
      if (locationName && timetableInput) {
        timetableInput.value = locationName;
      }
      Hafas.bind(_me.Controller.Timetable.processStopInput, _me)({loc: location});
    }
    if (_isLocHistory !== true) {
      Hafas.ps.pub('/tracking/event/favorite-location-selected', [{typ: 'event', key: 'favorite-location-selected'}]);
      Hafas.ps.pub('/tracking/event/locationsearch-favorite-selected', [{
        typ: 'event',
        key: 'locationsearch-favorite-selected'
      }]);
    } else {
      Hafas.ps.pub('/tracking/event/history-location-selected', [{typ: 'event', key: 'history-location-selected'}]);
    }

    var highlightingParams = {type: data.type};
    if (viaIndex !== undefined) {
      highlightingParams.viaIndex = viaIndex;
    }
    // Bestehendes Highlighting zu erst entfernen (ggfs. vorherigen Fehlerstatus löschen)
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput', [Hafas.Core.extend(true, Hafas.Core.clone(highlightingParams), {className: 'js_highLightingError'})]);

    // Auswirkungen auf Fehler-Highlighting anderer Felder prüfen (wenn Start & Ziel z.B. gleich waren, sich eins davon aber nun ändert kann, der Fehler im "Partner"-Feld auch resettet werden
    if (data.type == 'dep' || data.type == 'arr') {
      var inputErrors = _me.Controller.TP.instance.validateQueryLocations();
      if (inputErrors.DEP_ARR_IDENTICAL === undefined) {
        var linkedInputType = (data.type == 'dep') ? 'arr' : 'dep';
        Hafas.ps.pub('/GUI/common/removeHighlightingFromInput', [{
          type: linkedInputType,
          className: 'js_highLightingError'
        }]);
      }
    }

    // Highlighting im Inputfeld anzeigen
    Hafas.ps.pub('/GUI/common/highlightingInput', [highlightingParams]);

    Hafas.ps.pub('/GUI/smallAlert/hide');
    // Wenn Popover genutzt wird, muss dieses nach Einfügen von Start/Ziel/Via wieder geschlossen werden
    if (Hafas.Util.isPopoverRequired()) {
      Hafas.ps.pub('/favorites/closeLocationPopover', []);
    }
  }, this));

  // Linie ausw�hlen
  Hafas.ps.sub('/favorites/setLine', Hafas.bind(function (data) {
    var hitSearch = (typeof data.hitSearch !== 'undefined' ? data.hitSearch : true);
    if (data.context == 'linesearch') {
      if (data.hasOwnProperty('storage') && (data.storage === "history")) {
        Hafas.ps.pub('/linesearch/selectLineFromHist', [{lineId: data.lineId, hitSearch: hitSearch}]);
      } else {
        Hafas.ps.pub('/linesearch/selectLineFromFav', [{lineId: data.lineId, hitSearch: hitSearch}]);
      }
    } else if (data.context == 'timetable') {
      var dataStorage = "lines";
      if (data.storage === "history") {
        dataStorage += "History";
      }
      var line = _me.Controller.Favorites.instance.getLineById(data.lineId, dataStorage);
      Hafas.bind(_me.Controller.Timetable.processLineInput, _me)({line: line, hitSearch: hitSearch});
    }
    // send the input id as a type to highlightingInput method
    Hafas.ps.pub('/GUI/common/highlightingInput', [{type: data.context}]);

  }, this));

  // Set connection
  Hafas.ps.sub('/favorites/setConnection', Hafas.bind(function (data) {
    // If options were previously set, they must be reset
    Hafas.ps.pub('/options/reset');
    if(Hafas.Config.TP.vias.showInForm) {
      var viaCnt = this.Controller.TP.instance.getViaCount();
      for(var viaIndex = viaCnt - 1; viaIndex >= 0; viaIndex--) {
        _me.Controller.TP.instance.clearVia(viaIndex);
        // Remove marker on map
        _me.Controller.Map.clearLocationMarker.bind(this)("via", {index: viaIndex});
      }
    }

    // Reset displayed error statuses in form
    _me.Controller.TP.resetFormErrors();
    _me.Controller.TP.markerIsLoaded = false;
    var connection = _me.Controller.Favorites.instance.getConnectionById(data.id, data.storage);
    for (var k in connection) {
      if (typeof connection[k].lid != "undefined") {
        _me.Controller.TP.instance.setLocation(k, connection[k]);
      }
      if (typeof connection[k].mod != "undefined") {
        _me.Controller.TP.options.injectModifiedModel(connection[k].mod);
      }
    }

    // Reset active selection
    delete this.Controller.TP.activeSelection;
    delete this.Controller.TP.scrollButtonsState;

    // Check if vias have been entered, if yes show via status in form
    if(Hafas.Config.TP.vias.showInForm)
      this.Controller.TP.updateViaFieldVisibility.bind(this)(false);
    var viaCnt = this.Controller.TP.instance.getViaCount();
    if (Hafas.Config.TP.vias.showInForm && !this.Controller.TP.viasOpen) {
      var statusViaContainer = Hafas('#HFS_ViaStatusDisplay', false);
      var viaStatusText = Hafas('#HFS_ViaStatusText', false);
      if (viaStatusText !== null) {
        viaStatusText.innerHTML = this.Controller.TP.getViaStatusText.bind(this)();
      }
      if(viaCnt > 0){
        Hafas.Util.gui.setVisibility(statusViaContainer,true);
      }else{
        Hafas.Util.gui.setVisibility(statusViaContainer,false);
      }
    }

    if (((data.hitSearch && Hafas.Util.isPopoverRequired())) || !Hafas.Util.isPopoverRequired()) {
      var form = Hafas.Core.newType("hafasValidation", {
        form: document.formTripsearch   // TO DO Formular�bergabe
      });
      if (form.valid) {
        if (Hafas.Config.TP.vias.showInForm) {
          // Show Via Form collapsed
          if (Hafas.Config.TP.vias.showInForm && Hafas.Config.TP.unifiedPlanner.show && this.Controller.TP.currentView == 'index') {
            this.Controller.TP.hideViaForm.bind(this)();
          }
        }

        // Disable search button, when a location has been selected from the favorites
        Hafas.bind(_me.Controller.App.triggerLoadingImage, this)(document.formTripsearch.elements.submitTPForm);

        // close all additional resultcontainer
        Hafas.ps.pub('/GUI/results/additional/hideAll');

        // hide ResultOverview + Detail
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        _me.Controller.TP.visibleClusterGroup = _me.Controller.TP.getCurrentClusterBitmask();
        _me.Controller.TP.instance.search({
          ptCallback: Hafas.bind(_me.Controller.TP.showResultOverview, _me),
          ivCallback: Hafas.bind(_me.Controller.TP.showIVResultOverview, _me)
        });
      }
    }

    // Tracking
    // Hier muss das Speicherobjekt untersucht werden, ob es sich um einen Favoriten oder nur um einen History-Eintrag
    // handelt. Klick auf dieses Element wird auf 2 unterschiedliche Arten getrackt
    // Muss für die Ortssuche auch getan werden
    var ch = 0, chLen = _me.Controller.Favorites.instance.data.connectionsHistory.length;
    var _isHistory;
    // Wenn kein history-Eintrag vorhanden ist, kann es nur Favorit sein
    if (chLen <= 0) {
      _isHistory = false;
    } else {
      // Prüfe die History-Einträge
      for (ch; ch < chLen; ch++) {
        var _entry = _me.Controller.Favorites.instance.data.connectionsHistory[ch];

        if (_entry.opt.hash == connection.opt.hash) {
          _isHistory = true;
        }
      }
    }

    if (_isHistory === true) {
      Hafas.ps.pub('/tracking/event/use-history', [{typ: 'event', key: 'use-history'}]);
      Hafas.ps.pub('/tracking/event/history-connection-selected', [{typ: 'event', key: 'history-connection-selected'}]);
    } else {
      Hafas.ps.pub('/tracking/event/use-favorite', [{typ: 'event', key: 'use-favorite'}]);
      Hafas.ps.pub('/tracking/event/favorite-connection-selected', [{
        typ: 'event',
        key: 'favorite-connection-selected'
      }]);
    }
    if (Hafas.Util.isPopoverRequired()) {
      Hafas.ps.pub('/GUI/common/highlightingInput', [{type: 'dep'}]);
      Hafas.ps.pub('/GUI/common/highlightingInput', [{type: 'arr'}]);
      Hafas.ps.pub('/tp/favorites/connectionsHistory/closePopover', []);
    }

  }, _me));

  // Update saved connections when a smart location has been updated
  Hafas.ps.sub('/favorites/smartLocations/locationUpdated', Hafas.bind(function (loc) {
    this.Controller.Favorites.instance.updateSmartLocationInConnections(loc);
    Hafas.ps.pub('/map/createFavoriteMarker', [loc, {forceRedraw: true}]);
  }, _me));

  // Update locations saved in suggest instances when a smart location has been updated
  Hafas.ps.sub('/favorites/smartLocations/locationUpdated', Hafas.bind(function (loc) {
    var suggestInstances = Hafas.Modules.Suggest.getSuggestInstances();
    for (var i = 0; i < suggestInstances.length; i++) {
      // Iterate through suggest instances and update the location set in the suggests, if the activeLoc matches the smartLocation.
      // Furthermore select the location in the suggest again to trigger the selectLocation function from other Modules, to give them
      // the latest smartLocation information too. Otherwise the revitalization can overwrite smartLocation information after a search
      var suggestInstance = suggestInstances[i];
      if (suggestInstance.activeLoc !== null) {
        // Check for matching lid to be interpreted as the same location
        if (suggestInstance.activeLoc.lid === loc.lid) {
          // Match found, update (smartLocation) information in suggest and other modules
          suggestInstance.setLocation(loc);
          suggestInstance.selectLocation(loc, false);
        }
      }
    }
  }, _me));

  /**
   * Accessibility Helper for favorites/history list changes
   *
   * @param {string} storage Either 'favorites' or 'history'
   * @param {object} params Containing 'arr' and 'dep' or 'lid' in order to check for the correct station name to announce
   * @param {boolean} added Favorite has been added or removed from a list?
   */
  function _announceFavoriteChange(storage, params, added) {
    var i18nKey;
    var i18nProps;

    if (params.dep && params.arr) {
      switch (storage) {
        case 'favorites':
          i18nKey = added ? 'Favorites.t_N_addedConnectionToFavorites' : 'Favorites.t_N_removedConnectionFromFavorites';
          break;
        case 'history':
          // no check for 'added', because this case does not exist
          i18nKey = 'Favorites.t_N_removedConnectionFromHistory';
          break;
        default:
          return;
      }
      i18nProps = {
        from: params.dep.name,
        to: params.arr.name
      };
      if (params.opt && params.opt.txt) {
        i18nProps.options = params.opt.txt;
      }
    } else {
      switch (storage) {
        case 'favorites':
          i18nKey = added ? 'Favorites.t_N_itemAddedToFavorites' : 'Favorites.t_N_itemRemovedFromFavorites';
          break;
        case 'history':
          // no check for 'added', because this case does not exist
          i18nKey = 'Favorites.t_N_itemRemovedFromHistory';
          break;
        default:
          return;
      }

      i18nProps = {item: ''};

      // locations
      if (params.lid)
        i18nProps.item = params.name;
      // lines
      else if (params.lineId)
        i18nProps.item = params.prodResolved.name;
    }

    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get(i18nKey, i18nProps));
  }

  /* Location vom Verlauf zu Favoriten verschieben */
  Hafas.ps.sub('/favorites/addLocToFav', Hafas.bind(function (locKey, event) {

    var location = Hafas.Modules.Render.objectKeeper.get(locKey);

    if (typeof location.id === 'number') {
      _me.Controller.Favorites.instance.moveLocationFromHistoryToFav(location.id);
    } else {
      _me.Controller.Favorites.instance.addLocationToFav(location);
    }

    _announceFavoriteChange('favorites', location, true);

    // Tracking
    Hafas.ps.pub('/tracking/event/save-favorite', [{typ: 'event', key: 'save-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-location-marked', [{typ: 'event', key: 'favorite-location-marked'}]);
    Hafas.ps.pub('/favorites/updateFlyout', [location.lid])

    // Event nicht weiterleiten
    Hafas.Util.stopPropagation(event);
  }, _me));

  /* Favorit entfernen und automatisch dem Verlauf beif�gen */
  Hafas.ps.sub('/favorites/removeFavToHistory', Hafas.bind(function (locKey, event) {
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);

    // If the location has a main mast, that main mast should be used
    if (location.mMastLocResolved) {
      location = location.mMastLocResolved;
    }

    Hafas.ps.pub('/favorites/updateFlyout', [location.lid]);

    if (typeof location.id === 'number') {
      _me.Controller.Favorites.instance.removeLocationFav(location.id);
    } else {
      _me.Controller.Favorites.instance.removeLocationFav(location);
    }
    _announceFavoriteChange('favorites', location, false);
    // Tracking
    Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-location-unmarked', [{typ: 'event', key: 'favorite-location-unmarked'}]);

    // Event nicht weiterleiten
    Hafas.Util.stopPropagation(event);
  }, _me));

  Hafas.ps.sub('/favorites/toggleFlyoutFavorite', Hafas.bind(function (locKey) {
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);

    var favBunStatus;
    if (this.Controller.Favorites.instance.isLocationStored(this.Controller.Favorites.instance.data.locations, location)) {
      this.Controller.Favorites.instance.removeLocationFav(this.Controller.Favorites.instance.getLocationIndex(location));
      _announceFavoriteChange('favorites', location, false);
      // Tracking
      Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
      Hafas.ps.pub('/tracking/event/favorite-location-unmarked', [{typ: 'event', key: 'favorite-location-unmarked'}]);
    } else {
      this.Controller.Favorites.instance.addLocation(location, '');
      _announceFavoriteChange('favorites', location, true);
      // Tracking
      Hafas.ps.pub('/tracking/event/save-favorite', [{typ: 'event', key: 'save-favorite'}]);
      Hafas.ps.pub('/tracking/event/favorite-location-marked', [{typ: 'event', key: 'favorite-location-marked'}]);
    }

    Hafas.ps.pub('/favorites/updateFlyout', [location.lid]);
  }, _me));

  Hafas.ps.sub('/favorites/updateFlyout', Hafas.bind(function (lid) {
    if (!Hafas.Util.isCookieTypeActive('functional')) {
      return;
    }

    var flyout = Hafas('#mapToolbox', false);

    if (flyout === null) {
      return;
    }

    var favBtn = Hafas('.js_favBtn', flyout, false)[0];

    if (typeof favBtn === 'undefined') {
      return;
    }

    var favBtnLid = favBtn.getAttribute('data-lid');
    var favBtnMainMastLid = favBtn.getAttribute('data-main-mast-lid');

    if ((favBtnLid === null || lid !== favBtnLid) && (favBtnMainMastLid === null || lid !== favBtnMainMastLid)) {
      return;
    }

    if (favBtn.querySelector('i').classList.contains('haf_ic_fav')) {
      favBtn.querySelector('i').className = 'haf_ic_fav_active';
      favBtn.querySelector('.lyr_tooltipText').innerHTML = Hafas.Modules.i18n.get('common.mouseover.t_N_DeleteFromFav');
    } else {
      favBtn.querySelector('i').className = 'haf_ic_fav';
      favBtn.querySelector('.lyr_tooltipText').innerHTML = Hafas.Modules.i18n.get('common.mouseover.t_N_ChooseAsFav');
    }
  }, _me));

  /* Verbindung vom Verlauf zu Favoriten verschieben */
  Hafas.ps.sub('/favorites/addConnToFav', Hafas.bind(function (params) {
    var _entry = _me.Controller.Favorites.instance.getConnectionByHash(params, 'History');
    _me.Controller.Favorites.instance.addConnectionFromHistory(params);

    _announceFavoriteChange('favorites', _entry, true);

    // Tracking
    Hafas.ps.pub('/tracking/event/save-favorite', [{typ: 'event', key: 'save-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-connection-marked', [{typ: 'event', key: 'favorite-connection-marked'}]);
  }, _me));

  /* Connection Favorit entfernen und automatisch dem Verlauf beif�gen */
  Hafas.ps.sub('/favorites/removeConnToHistory', Hafas.bind(function (params) {
    var _entry = _me.Controller.Favorites.instance.getConnectionByHash(params);
    _me.Controller.Favorites.instance.removeConnectionFav(params);

    _announceFavoriteChange('favorites', _entry, false);

    Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
    Hafas.ps.pub('/tracking/event/favorite-connection-unmarked', [{typ: 'event', key: 'favorite-connection-unmarked'}]);
  }, _me));

  Hafas.ps.sub('/favorites/addLineToFav', Hafas.bind(function (line) {
    _me.Controller.Favorites.instance.addLine(line);
    Hafas.ps.sub('/app/events/resize');

    _announceFavoriteChange('favorites', line, true);
  }));

  Hafas.ps.sub('/favorites/addLineToHistory', Hafas.bind(function (line) {
    _me.Controller.Favorites.instance.addLineToHistory(line);
  }));

  Hafas.ps.sub('/favorites/removeLine', Hafas.bind(function (lineId) {
    var removedLine = _me.Controller.Favorites.instance.removeLine(lineId);

    _announceFavoriteChange('favorites', removedLine, false);
  }, _me));

  Hafas.ps.sub('/favorites/addLineFromHist', Hafas.bind(function (lineId) {
    var addedLine = _me.Controller.Favorites.instance.addLineFromHist(lineId);

    _announceFavoriteChange('favorites', addedLine, true);
  }, _me));

  // Wenn die Fensterbreite sich verändert, müssen die Liniensignets an der Historie / den Favoriten neu berechnet werden
  Hafas.ps.sub('/app/events/resize', Hafas.bind(function () {
    var historyWrapperList = Hafas('[data-render-element="history-wrapper"]', true);
    for (var i = 0; i < historyWrapperList.length; i++) {
      var historyWrapper = historyWrapperList[i];
      if (Hafas.Util.gui.isVisible(historyWrapper)) { // Nur ausführen, wenn die Historie / Favoriten auch sichtbar sind
        HafasWebapp.prototype.Controller.GUI.simplifyLineSignetsDebouncer = HafasWebapp.prototype.Controller.GUI.simplifyLineSignetsDebouncer || Hafas.Util.debounce(function (historyWrapper) {
          var historyLocation = Hafas('.lyr_atomProductList', true, historyWrapper);
          if (historyLocation.length > 0) {
            // historyWrapper beinhaltet alle Favoriten/Historieneinträge, in simplifyLineSignets werden alle .lyr_atomProductList darin gesucht
            // historyLocation ist Bereich für Signets; clientWidth hat durch flex:1 volle Breite, aber durch overflow:hidden nicht größer als möglich
            Hafas.Util.gui.simplifyLineSignets(historyWrapper);
          }
        }, 100);
        HafasWebapp.prototype.Controller.GUI.simplifyLineSignetsDebouncer(historyWrapper);
      }
    }
  }, _me));

  /* Update der Oberfl�che */
  Hafas.ps.sub('/favorites/update', Hafas.bind(function () {
    // TODO: FavoriteController! (Ja, sollte mal jemand machen)
    var tempModel = null;
    var tempTpl, tempTarget = "";
    var favInstance = _me.Controller.Favorites.instance;
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    if (typeof Hafas.Config.UI.showFavoriteBox == 'undefined' || Hafas.Config.UI.showFavoriteBox == true) {
      if (_me.Controller.Favorites.main.appContext == "SQ") {
        if (Hafas.Config.SQ.allType) {
          tempModel = _me.Controller.Favorites.instance.getData();
          // add the length of favorite locations/ locationsHistory together
          tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
        } else {
          tempModel = _me.Controller.Favorites.instance.getData("S");
          // add the length of favorite locations/ locationsHistory together
          tempModel.entryLengthLoc = favInstance.getAmountOfVisibleItems(["locations", "locationsHistory"], tempModel);
        }
        tempTpl = "SQ_AtomTplFieldFav_Stations";
        tempTarget = "HFS_FavLocationsSQ";
      } else if (_me.Controller.Favorites.main.appContext == "TP") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempTpl = "TP_AtomTplFieldFav_Locations";
        tempTarget = "HFS_FavLocationsTP";
        // add the length of favorite locations/ locationsHistory together
        tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;
        tempModel.entryLengthCon = tempModel.connections.length + tempModel.connectionsHistory.length;
        tempModel.className = 'hfs_favLocationsTab';
        var conModel = Hafas.Core.clone(_me.Controller.Favorites.instance.getData());
        conModel.className = 'hfs_favConnectionsTab';
        Hafas.Modules.Render.render({
          target: "HFS_FavConnectionsTP",
          template: "TP_AtomTplFieldFav_Connections",
          model: tempModel
        });
      } else if (_me.Controller.Favorites.main.appContext == "LineSearch") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempModel.entryLengthLines = tempModel.lines.length + tempModel.linesHistory.length;
        tempModel.context = "linesearch";
        tempTpl = "LineSearch_TplFavorites";
        tempTarget = "HFS_LineFavorites";
      } else if (_me.Controller.Favorites.main.appContext == "Reachability") {
        tempModel = _me.Controller.Favorites.instance.getData();
        tempTpl = "Reachability_AtomTplFieldFav_Stations";
        tempTarget = 'HFS_FavLocationsReachability';
        tempModel.entryLengthLoc = tempModel.locations.length + tempModel.locationsHistory.length;

      } else if (_me.Controller.Favorites.main.appContext == "Timetable") {
        var selectedInput = Hafas.bind(_me.Controller.Timetable.getSelectedInput, _me)();
        if (selectedInput === "stop") {
          tempModel = _me.Controller.Favorites.instance.getData("S");
          tempModel.type = "timetable";
          tempTpl = "SQ_AtomTplFieldFav_Stations";
          tempTarget = "HFS_FavLocationsTimetable";
          // add the length of favorite locations/ locationsHistory together
          tempModel.entryLengthLoc = favInstance.getAmountOfVisibleItems(["locations", "locationsHistory"], tempModel);
        } else if (selectedInput === "line") {
          tempModel = Hafas.bind(_me.Controller.Timetable.processFavoritesData, _me)(_me.Controller.Favorites.instance.getData());
          tempModel.context = "timetable";
          _me.Controller.Favorites.instance
          tempModel.entryLengthLines = tempModel.lines.length + tempModel.linesHistory.length;
          tempTpl = "LineSearch_TplFavorites";
          tempTarget = "HFS_TimetableFavorites";
        }
      }

      if (tempModel && tempModel.locations) {
        tempModel.locations.forEach(function (loc) {
          Hafas.ps.pub('/map/createFavoriteMarker', [loc]);
        });
      }

      var callback = function () {
        // Favorite-Elemente hier nochmal suchen, da sonst keine clientWidth vorhanden im Callback
        var historyWrapperList = Hafas('[data-render-element="history-wrapper"]', true);
        for (var i = 0; i < historyWrapperList.length; i++) {
          var historyWrapper = historyWrapperList[i];
          if (Hafas.Util.gui.isVisible(historyWrapper)) { // Nur ausführen, wenn die Historie / Favoriten auch sichtbar sind
            var historyLocation = Hafas('.lyr_atomProductList', true, historyWrapper);
            if (historyLocation.length > 0) {
              Hafas.Util.gui.simplifyLineSignets(historyWrapper);
            }
          }
        }
        Hafas.Util.gui.restoreFocus(focusSelector);
      }

      if (tempTarget.length > 0 && Hafas("#" + tempTarget) != null) {
        Hafas.Modules.Render.render({
          target: tempTarget,
          template: tempTpl,
          model: tempModel
        }, callback);
        Hafas.ps.pub('/app/events/resize');
      }
    }

    // TODO: FavoriteController!
    var favIcons = Hafas('[data-render="favIcon"]', true);
    favIcons.forEach(function (favIcon) {
      var lid = favIcon.getAttribute('data-lid');
      if (lid) {
        var name = favIcon.getAttribute('data-name');
        var location = {
          lid: lid, // ok to only use lid + name here because we get the full location in the rendered favButton atom
          name: name
        };
        var atomParameter = {
          partialId: favIcon.getAttribute('data-partial')
        }
        var focus = false;
        if (document.activeElement === favIcon.firstElementChild) {
          focus = true;
        }
        var favModel = Hafas.Modules.Atoms.createAtomModel('common.favorites.locations.favButton', new Hafas.Modules.Render.RenderModel(location), atomParameter);

        favIcon.firstElementChild.parentNode.removeChild(favIcon.firstElementChild);

        Hafas.Modules.Render.render({
          target: favIcon,
          template: 'Common_AtomTplButton',
          model: favModel
        }, function () {
          if (focus) {
            Hafas.Util.gui.focusElement(favIcon.firstElementChild)
          }
        });

      }
    });

    var contextMenuConfig = {
      trigger: ['clickRight'],
      stickTo: 'bottom|right',
      useMousePosition: true,
      zIndex: 20000,
      content: [
        {
          text: Hafas.Modules.i18n.get('common.label.t_N_delete'),
          event: function (contextMenu) {
            var elem = contextMenu.parent;
            var opts = {
              storage: elem.parentElement.dataset.storage,
            };

            for (var entry in elem.dataset) {
              opts[entry] = elem.dataset[entry];
            }

            Hafas.ps.pub('/favorites/deleteEntry', [opts]);

            // Für das Tracking kann opts.storage ausgelesen und verwendet werden.
            // Hier sind wieder alte und neue trackingbezeichner bzw LEGACY/BASIS/PREMIUM vermischt!
            switch (opts.storage) {
              case 'locations':
                // delete favorite location
                Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
                break;
              case 'locationsHistory':
                // delete history location
                Hafas.ps.pub('/tracking/event/history-location-deleted', [{
                  typ: 'event',
                  key: 'history-location-deleted'
                }]);
                break;
              case 'connections':
                // delete favorite connection
                Hafas.ps.pub('/tracking/event/delete-favorite', [{typ: 'event', key: 'delete-favorite'}]);
                break;
              case 'connectionsHistory':
                // delete history connection
                Hafas.ps.pub('/tracking/event/history-connection-deleted', [{
                  typ: 'event',
                  key: 'history-connection-deleted'
                }]);
                break;
            }
          }
        }
      ]
    };
    Hafas('.lyr_favoriteRow', true).forEach(function (elem) {
      var favType = elem.getAttribute('data-favorite-type', false);
      if (!Hafas.Util.isPopoverRequired()) {
        Hafas.Core.newType('HafasContextMenu', contextMenuConfig).addTo(elem);
      }
    });

    Hafas.ps.pub('/GUI/common/fixedElements/setHeights', [{me: this}]);
  }, _me));

  Hafas.ps.sub('/favorites/redraw', Hafas.bind(function () {
    _me.Controller.Favorites.instance.getData().locations.forEach(loc => {
      Hafas.ps.pub('/map/createFavoriteMarker', [loc, {forceRedraw: true}]);
    });
  }, this));

  Hafas.ps.sub('/favorites/trackDialogAction', Hafas.bind(function (action) {
    Hafas.ps.pub('/tracking/event/tripplanner-location-history-dialog-' + action, [{
      typ: 'event',
      key: 'tripplanner-location-history-dialog-' + action
    }]);
  }, this));

  Hafas.ps.sub('/favorites/clearHistoryOverlay', Hafas.bind(function (favCat) {
    var me = this;
    var model = {
      msg: Hafas.Modules.i18n.get("Favorites.t_N_delete" + favCat + "OverlayText"),
      button_text_ok: Hafas.Modules.i18n.get("Favorites.t_N_delete"),
      button_text_cancel: Hafas.Modules.i18n.get("common.label.t_N_cancel"),
      event_ok: "Hafas.ps.pub('/favorites/clear" + favCat + "History'); ",
      event_cancel: "Hafas.ps.pub('/common/cancelOverlay'); "
    };
    Hafas.Modules.Render.render({
      file: 'common.overlay.html',
      template: 'Overlay_TplDeleteFavorites',
      model: model
    },
    function (html) {
      overlay = Hafas.Core.newType("HafasOverlay", {
        app: me,
        title: Hafas.Modules.i18n.get("Favorites.t_N_delete" + favCat + "OverlayHeader"),
        outputHTML: html,
        cssClass: 'hfs_favoritesOverlay'
      });
    }
    );
  }, _me));

  /* Location-History l�schen */
  Hafas.ps.sub('/favorites/clearLocationHistory', Hafas.bind(function () {
    Hafas.ps.pub('/common/cancelOverlay');
    _me.Controller.Favorites.instance.clearLocationHistory();
  }, _me));


  /* Connection-History l�schen */
  Hafas.ps.sub('/favorites/clearConnectionHistory', Hafas.bind(function () {
    Hafas.ps.pub('/common/cancelOverlay');
    _me.Controller.Favorites.instance.clearConnectionHistory();
  }, _me));

  Hafas.ps.sub('/common/cancelOverlay', Hafas.bind(function () {
    if (typeof overlay != "undefined") {
      overlay.close();
    }
  }, _me));

  /* Occurs when right-click menu is used in order to remove favorite/history entry */
  Hafas.ps.sub('/favorites/deleteEntry', Hafas.bind(function (opts) {
    var removedEntry = _me.Controller.Favorites.instance.clearFavEntry(opts);
    Hafas.ps.pub('/map/removeFavoriteMarker', [removedEntry]);

    var storage;

    switch (opts.storage) {
      case 'locations':
      case 'connections':
      case 'lines':
        storage = 'favorites';
        break;
      case 'locationsHistory':
      case 'connectionsHistory':
      case 'linesHistory':
        storage = 'history';
        break;
      default:
        return;
    }
    _announceFavoriteChange(storage, removedEntry, false);
    Hafas.ps.pub('/favorites/updateFlyout', [opts.lid])
  }, _me));

  Hafas.ps.sub('/IFrameAPI/CloseIFrameFullscreen', Hafas.bind(function () {
    if (Hafas.Modules.IFrameApi)
      Hafas.Modules.IFrameApi.sendCloseIframeFullscreen();
  }));

  Hafas.ps.sub('/common/openURL', Hafas.bind(_me.Controller.App.openURL, _me));

  // Beim Wechsel von Tabs müssen die Favoriten noch einmal aktualisiert werden mit simplifyLineSignets
  Hafas.ps.sub('/GUI/components/segCon/callback', Hafas.bind(function () {
    Hafas.ps.pub('/favorites/update');
  }, _me));

  // Revitalization
  Hafas.ps.sub('/favorites/revitalizeLocations', Hafas.bind(function (params) {
    if (_me.Controller.Favorites == null || _me.Controller.Favorites.instance == null) {
      // We need the favorites instance here
      return;
    }

    /**
     * Helper function to iterate over connection arrays and check if the locations exist in another list, add them if not
     * @method _addLocsFromConnectionArray
     * @param {Array} connectionArr Array of connection objects
     * @param {array} checklist Array with collected locations in which the connection locations should be searched and added
     * @private
     */
    var _addLocsFromConnectionArray = function (connectionArr, checklist) {
      for (var i = 0; i < connectionArr.length; i++) {
        var locDep = connectionArr[i].dep;
        var locArr = connectionArr[i].arr;
        var locDepFound = false;
        var locArrFound = false;
        // Check if the locations from connections are already inside the list
        for (var j = 0; j < checklist.length; j++) {
          if (locDep.lid === checklist[j].lid || locDep.name === checklist[j].name) {
            locDepFound = true;
          }
          if (locArr.lid === checklist[j].lid || locArr.name === checklist[j].name) {
            locArrFound = true;
          }
        }
        // Add the locations from the favorite connections if not found in list already
        if (locDepFound === false) {
          checklist.push(locDep);
        }
        if (locArrFound === false) {
          checklist.push(locArr);
        }
      }
    }

    params = params || {};
    var callback = params.callback;

    // Revitalize all locations ...
    var favoritesData = _me.Controller.Favorites.instance.getData();
    var favoriteLocs = favoritesData.locations;
    var historyLocs = favoritesData.locationsHistory;

    // ... also from connections
    var favoriteConnections = favoritesData.connections;
    var historyConnections = favoritesData.connectionsHistory;

    // Get a list of favorites and history
    var locList = favoriteLocs.concat(historyLocs);

    // Add the locations from the connections: They might be already in the list, but that must not be the case
    _addLocsFromConnectionArray(favoriteConnections, locList);
    _addLocsFromConnectionArray(historyConnections, locList);

    // Revitalize
    Hafas.Util.revitalizeLocList(locList, callback);
  }, _me));

  Hafas.ps.sub('/app/showCookieSettings', Hafas.bind(_me.Controller.App.showCookieSettings, _me));
  Hafas.ps.sub('/app/acceptCookieSettings', Hafas.bind(_me.Controller.App.acceptCookieSettings, _me));
  Hafas.ps.sub('/app/showCookieSettings', Hafas.bind(_me.Controller.GUI.common.hideCookieSettingsHint, _me));
  Hafas.ps.sub('/app/acceptCookieSettings', Hafas.bind(_me.Controller.GUI.common.hideCookieSettingsHint, _me));
  Hafas.ps.sub('/app/toggleCookieFeaturesHint', Hafas.bind(function (params) {
    // Toggle cookie-features hint according to checkbox status
    var cookieType = (params.cookieType !== undefined) ? params.cookieType : "functional"; // default: functional
    var target = Hafas('#HFS_CookieFeaturesHint_' + cookieType, false);
    var checkbox = Hafas('#HFS_CookieOption' + cookieType, false);
    if (target !== null && checkbox !== null) {
      target.hidden = checkbox.checked;
    }
  }, _me));


  // Smart locations
  // Hides the smart locations container view
  Hafas.ps.sub('/favorites/smartLocations/closeView', Hafas.bind(function () {
    var target = Hafas('#' + this.smartLocationsContainer, false);
    if (target !== null) {
      Hafas.Util.gui.setVisibility(target, false);
    }
  }, _me));

  // Empty Edit Smart Location screen was opened and a location selected via suggest
  Hafas.ps.sub('/favorites/smartLocations/addInput', Hafas.bind(function (params) {
    // If multiple locations are selected after each other, params.loc might not only contain smartLocation information
    // but also real location information, therefore we have to use only the smartLocation information as a basis to
    // not copy other location specific information
    var loc = {
      smartLocation: {}
    };
    if (params.loc.smartLocation !== undefined) {
      Object.extend(loc.smartLocation, params.loc.smartLocation);
    }

    // Delete preferredStops if the new type is now a station and preferredStops therefore not possible to select
    if (params.selectedLocation.type === "S") {
      delete loc.smartLocation.preferredStops;
    }

    // Use the selected location as edit screen data
    this.Controller.Favorites.instance.smartLocationEditModel.originalLocation = params.selectedLocation;
    this.Controller.Favorites.instance.smartLocationEditModel.loc = Object.extend(loc, Hafas.Core.clone(params.selectedLocation));

    // If a name was already entered before the location was selected, we have to update the description
    var locKey = Hafas.Modules.Render.objectKeeper.keep(this.Controller.Favorites.instance.smartLocationEditModel.loc);
    var nameInput = Hafas('#HFS_SmartLocationChangeName', false);
    Hafas.ps.pub('/favorites/smartLocations/changeName', [{locKey: locKey, input: nameInput}]);
  }, _me));

  // Renders the smart locations edit view, adds it to the history and hides the favorite/form container
  Hafas.ps.sub('/favorites/smartLocations/edit', Hafas.bind(function (params) {

    var me = this;
    var context = Hafas.getWebAppContext();
    var target = params.trigger !== undefined ? Hafas('#' + params.trigger.getAttribute('aria-controls'), false) : Hafas('#' + params.target);
    var focusSelector = Hafas.Util.gui.getFocusElementSelector(); // Remember focused element to restore later
    var mode = params.mode || "edit";
    var showLocationSuggest = params.showLocationSuggest || false;

    // We must save the original location and get a copy of its smart location info, we should not edit originalLocation
    var originalLocation = {};
    if (params.locKey !== undefined) {
      originalLocation = Hafas.Modules.Render.objectKeeper.get(params.locKey);
    }

    var locationCopy = Hafas.Core.clone(originalLocation); // We need a copy as the original location should only be saved after button click

    if (params.isQuickFavorite === true) {
      if (locationCopy.smartLocation === undefined) {
        locationCopy.smartLocation = {};
      }
      if(params.isDefaultfav) {
        locationCopy.smartLocation = {
          name: params.name,
          prod: params.prod
        }
      }
      locationCopy.smartLocation.isQuickFavorite = true;
    }

    // Save these values to be accessible in different functions
    this.Controller.Favorites.instance.smartLocationEditModel.originalLocation = originalLocation;
    this.Controller.Favorites.instance.smartLocationEditModel.loc = locationCopy;

    // Save a state whether the favorite data has been changed
    this.Controller.Favorites.instance.smartLocationEditModel.valuesChanged = false;

    // Close popover
    if (Hafas.Util.isPopoverRequired()) {
      Hafas.ps.pub('/favorites/closeLocationPopover', []);
    }

    // Count active quickFavorites to be able to deactivate the quickFavoritesSwitch if maximum is reached
    var quickFavsCount = 0;
    var favData = this.Controller.Favorites.instance.getData();
    var favLocations = [];
    if (favData) {
      favLocations = favData.locations;
    }
    for (var i = 0; i < favLocations.length; i++) {
      if (favLocations[i].smartLocation !== undefined && favLocations[i].smartLocation.isQuickFavorite === true) {
        quickFavsCount++;
      }
    }
    // Render smart locations
    Hafas.Modules.Render.render({
      file: 'common.smartlocations.html',
      target: target,
      template: 'SmartLocations_TplIndex',
      model: {
        loc: locationCopy,
        mode: mode,
        showLocationSuggest: showLocationSuggest,
        activeQuickFavorites: quickFavsCount
      }
    }, Hafas.bind(function (html) {
      // Toggle editFavorite container
      Hafas.Util.gui.setVisibility(target, true);

      // Hide form and favorites
      // TODO: Check in formbased, there we don't hide these containers in option toggle
      Hafas.ps.pub('/GUI/form/hide', [{}]);

      // Hide tabNavigationHeading to prevent doubled actionbars
      Hafas.ps.pub('/GUI/tabNavigationHeading/hide');

      // Add to history
      if (Hafas.Modules.History) {
        Hafas.Modules.History.addOrUpdateData(context, 'editSmartLocations', {previousFocusSelector: focusSelector, loc: locationCopy});
      }

      // Announce view change
      //announce header text
      var actionbarTitle = Hafas(".lyr_atomActionbarTitle", false, target);
      if (actionbarTitle !== null) {
        Hafas.Modules.a11y.Announce.assertive(actionbarTitle.innerText);
      }
      // focus first Element (Backbutton)
      Hafas.Util.gui.focusFirstElement(target);

      if (mode === "new" && me.Controller.Favorites.instance.smartLocationEditModel.loc.lid !== undefined) {
        // If we enter the edit view with mode "new" and already have a location, we want to turned a history location
        // into a favorite. Unlock the save button to be able to save this step.
        Hafas.ps.pub('/favorites/smartLocations/setSaveBtnDisabled', [false]);
      }

      // Initialize the suggest if it is shown
      if (params.showLocationSuggest === true) {
        if (locationCopy.type === undefined || locationCopy.type === "S") { // type is undefined if the edit screen is opened without editing a location
          // Hide the preferredStops input if there is no location or the locations is a station
          var preferredStopsContainer = Hafas('.lyr_smartLocationPreferredStopsWrapper', false);
          Hafas.Util.gui.setVisibility(preferredStopsContainer, false); // Hide initially
        }

        // Create suggest for preferred stop
        me.Controller.Favorites.instance.smartLocationInputSuggest = Hafas.Core.newType('hafasSuggest', {
          input: "SmartLocationSuggestInput",
          config: {
            useChooseFromMap: false
          },
          suggestType: "ALL",
          onSelect: function (selectedInput) {
            // Add stop to list and rerender view
            Hafas.ps.pub('/favorites/smartLocations/addInput', [{loc: locationCopy, selectedLocation: selectedInput}]);

            // Call edit screen again to render the elements with updated info and location reference
            var newParams = params; // We need the outer params with the new location and smartLocation
            if(typeof me.Controller.Favorites.instance.smartLocationEditModel.loc.smartLocation !== 'undefined'){
              // set values of smartLocations that may have changed since starting the editing of the favorite (and are independent of the selected location) to the current values (HDSWAPP-3785, HDSWAPP-3917)
              newParams.prod = me.Controller.Favorites.instance.smartLocationEditModel.loc.smartLocation.prod;
              newParams.name = me.Controller.Favorites.instance.smartLocationEditModel.loc.smartLocation.name;
              newParams.isQuickFavorite = me.Controller.Favorites.instance.smartLocationEditModel.loc.smartLocation.isQuickFavorite;
            }

            newParams.locKey = Hafas.Modules.Render.objectKeeper.keep(me.Controller.Favorites.instance.smartLocationEditModel.loc);
            Hafas.ps.pub('/favorites/smartLocations/edit',[newParams]); // Call pub instead of rendering because the suggests are created there

            // Marks this value as changed and handles the save button disabled state, force is needed because due to the
            // new rendering of the edit screen after location selection, the originalLocation is reset to the modified loc
            Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', [{force:true}]);
          },
          onClear: function () {},
          onBlur: function(){}
        });
        // Overwrite the mergeLists funnction from the hafasSuggest, to be able to filter out locations that are already
        // in the history
        this.Controller.Favorites.instance.smartLocationInputSuggest.overrides.customMergeFunction = function (instance, currentState, listDict) {
          var suggestList = listDict.suggestList;

          // Filter out the locations existing in preferredStops
          suggestList = suggestList.filter(function (suggestLoc) {
            // Find location in favorites/history based on lid or name to remove them if they exist in these lists
            var indexFavLoc = listDict.favoriteList.findIndex(function(favLocation) {
              var isFav = suggestLoc.original.lid === favLocation.original.lid || suggestLoc.original.name === favLocation.original.name;
              return isFav;
            });
            var indexHistoryLoc = listDict.historyList.findIndex(function(histLocation) {
              var isHist = suggestLoc.original.lid === histLocation.original.lid || suggestLoc.original.name === histLocation.original.name;
              return isHist;
            });
            // Let elements stay that could not be found in favorites / history
            var isNotFavoriteLoc = indexFavLoc === -1;
            var isNotHistoryLoc = indexHistoryLoc === -1;
            // It might be that the filtered favorites/historyList (see filterLocationList()) doesn't contain the
            // element, but it should be in there, due to a simple indexOf check on our side but a more complex check in the server
            var hasSmartLocInfo = suggestLoc.original.smartLocation !== undefined && Object.keys(suggestLoc.original.smartLocation).length > 0;
            return isNotFavoriteLoc === true && isNotHistoryLoc === true && hasSmartLocInfo === false;
          })

          return suggestList;
        }
      } // End of Location Input Suggest

      // Create suggest for preferred stop
      if (Hafas.Config.Favorites.SmartLocations.additionalFields.preferredStops === true && locationCopy.type !== "S") {
        this.Controller.Favorites.instance.smartLocationPreferredStopSuggest = Hafas.Core.newType('hafasSuggest', {
          input: "SmartLocationAddStop",
          config: {
            useChooseFromMap: false
          },
          suggestType: "S",
          onSelect: function (selectedPreferredStop) {
            // Add stop to list and rerender view
            Hafas.ps.pub('/favorites/smartLocations/addPreferredStop', [{loc: me.Controller.Favorites.instance.smartLocationEditModel.loc, preferredStop: selectedPreferredStop}]);
            // Reset the input value directly after selecting
            me.Controller.Favorites.instance.smartLocationPreferredStopSuggest.setInputText("");
            // Blur and focus input field after selecting a preferred stop to render suggest list again
            me.Controller.Favorites.instance.smartLocationPreferredStopSuggest.inp.blur();
            me.Controller.Favorites.instance.smartLocationPreferredStopSuggest.inp.focus();
          },
          onClear: function () {},
          onBlur: function(){}
        });
        // Overwrite the mergeLists funnction from the hafasSuggest, to be able to filter out locations that are already
        // in the preferredStops; Similar to linesearch override
        this.Controller.Favorites.instance.smartLocationPreferredStopSuggest.overrides.customMergeFunction = function (instance, currentState, listDict) {
          var list = listDict.suggestList;

          // only if there are no suggests, show history and favorites
          if (list.length === 0) {
            list = list.concat(listDict.favoriteList).concat(listDict.historyList);
          }

          // Filter out the locations existing in preferredStops
          if (locationCopy.smartLocation !== undefined && locationCopy.smartLocation.preferredStops !== undefined && locationCopy.smartLocation.preferredStops.length > 0) {
            list = list.filter(function (listLoc) {
              // Find location in smartLocation.preferredStops based on lid or name
              var indexPreferredStop = locationCopy.smartLocation.preferredStops.findIndex(function(preferredStopLoc) {
                return listLoc.original.lid === preferredStopLoc.lid || listLoc.original.name === preferredStopLoc.name;
              });
              // Let elements stay that could not be found in preferredStops
              return indexPreferredStop === -1;
            })
          }

          return list;
        }
      } // End of Preferred Stops Suggest
    }, this));
  }, _me));

  // Adds a preferred stop to the smart location information
  Hafas.ps.sub('/favorites/smartLocations/addPreferredStop', Hafas.bind(function (params) {
    if (Hafas.Config.Favorites.SmartLocations.additionalFields.preferredStops === false) {
      return;
    }

    // Add preferred stop
    if (params.loc.smartLocation === undefined) {
      params.loc.smartLocation = {};
    }
    if (params.loc.smartLocation.preferredStops === undefined) {
      params.loc.smartLocation.preferredStops = [];
    }
    params.loc.smartLocation.preferredStops.push(params.preferredStop);

    // Check if the maximum number of preferred stops is reached and cut the list if necessary
    var maxPreferredStops = Hafas.Config.Favorites.SmartLocations.maxPreferredStops;
    if (params.loc.smartLocation.preferredStops.length > maxPreferredStops) {
      params.loc.smartLocation.preferredStops = params.loc.smartLocation.preferredStops.slice(-maxPreferredStops);
    }

    // Marks this value as changed and handles the save button disabled state
    Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', []);

    // Rerender view
    Hafas.Modules.Render.render({
      file: 'common.smartlocations.html',
      target: Hafas('#HFS_SmartLocationsPreferredStops', false),
      template: 'SmartLocations_TplPreferredStops',
      model: {
        loc: params.loc
      }
    }, Hafas.bind(function (html) {
    }, this));
  }, _me));

  // Adds a smart location to the quickFavorites / Take-Me-There
  Hafas.ps.sub('/favorites/smartLocations/toggleQuickFavorite', Hafas.bind(function (params) {
    var loc = Hafas.Modules.Render.objectKeeper.get(params.locKey);

    if (loc.smartLocation === undefined) {
      loc.smartLocation = {};
    }

    // Mark as quickFavorite
    loc.smartLocation.isQuickFavorite = params.checked || false;

    // Marks this value as changed and handles the save button disabled state
    Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', []);
  }));

  // Removes a preferred stop from a smart location
  Hafas.ps.sub('/favorites/smartLocations/removePreferredStop', Hafas.bind(function (params) {
    // Remove preferred stop
    var loc = Hafas.Modules.Render.objectKeeper.get(params.locKey);
    if (loc.smartLocation !== undefined && loc.smartLocation.preferredStops !== undefined) {
      loc.smartLocation.preferredStops.splice(params.idx, 1);

      if (loc.smartLocation.preferredStops.length === 0) {
        delete loc.smartLocation.preferredStops;
      }
    }

    // Marks this value as changed and handles the save button disabled state
    Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', []);

    // Rerender view
    Hafas.Modules.Render.render({
      file: 'common.smartlocations.html',
      target: Hafas('#HFS_SmartLocationsPreferredStops', false),
      template: 'SmartLocations_TplPreferredStops',
      model: {
        loc: loc
      }
    }, Hafas.bind(function (html) {
    }, this));
  }, _me));

  // Adds the smart location name into the favorite and saves it
  Hafas.ps.sub('/favorites/smartLocations/changeName', Hafas.bind(function (params) {
    var loc = Hafas.Modules.Render.objectKeeper.get(params.locKey);
    var nameInput = params.input;
    var nameInputValue = Hafas.Core.sanitize(nameInput.value.trim());

    if (loc.smartLocation === undefined) {
      // Add smart location info if it doesn't exist
      loc.smartLocation = {};
    }
    var updateFav = true;

    if (nameInputValue !== "") {
      // We have a name, check for different name or description
      // If a quickFavorite is created, the name might be set before the location itself. We then have a name but
      // no description, therefore check if the old name and description matches
      if (nameInputValue !== loc.smartLocation.name || loc.name !== loc.smartLocation.descr) {
        // Name is new, add it to smart location info
        loc.smartLocation.name = nameInputValue;
        // Save the original name as description
        loc.smartLocation.descr = loc.name;
      } else {
        // Name is the same as before, don't do anything
        updateFav = false;
      }
    } else {
      // Empty name, remove name and descr (original name) from smart location
      delete loc.smartLocation.name;
      delete loc.smartLocation.descr;
    }

    // Update the location in the storage
    if (updateFav === true) {
      // Marks this value as changed and handles the save button disabled state
      Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', []);
    }
  }, _me));

  // Opens the overlay for changing the icon
  Hafas.ps.sub('/favorites/smartLocations/changeIconPopup', Hafas.bind(function (params) {
    var loc = Hafas.Modules.Render.objectKeeper.get(params.locKey);

    // Create the icon popup
    this.Controller.Favorites.instance.smartLocationIconOverlay = Hafas.Core.newType("HafasOverlay", {
      app: this,
      outputHTML: Hafas.Modules.Render.renderTemplate("SmartLocations_TplIconPopup", {loc: loc}),
      title: Hafas.Modules.i18n.get('Favorites.SmartLocations.t_N_selectIcon'),
      cssClass: 'lyr_smartLocationIconOverlay',
      onClose: function () {
      }
    });
  }, _me));

  // Saves the new icon into the location
  Hafas.ps.sub('/favorites/smartLocations/changeIcon', Hafas.bind(function (params) {
    var loc = Hafas.Modules.Render.objectKeeper.get(params.locKey);
    var icnClass = params.icnClass;

    // Add the icon to / remove the icon of the smart location
    if (loc.smartLocation === undefined) {
      loc.smartLocation = {};
    }
    if (params.removeIcon === true) {
      delete loc.smartLocation.prod;
    } else {
      loc.smartLocation.prod = icnClass;
    }

    // Close icon popup
    if (this.Controller.Favorites.instance && this.Controller.Favorites.instance.smartLocationIconOverlay) {
      this.Controller.Favorites.instance.smartLocationIconOverlay.close();
    }

    // Marks this value as changed and handles the save button disabled state
    Hafas.ps.pub('/favorites/smartLocations/valueHasChanged', []);

    // Rerender the icon on the view
    Hafas.Modules.Render.render({
      file: 'common.smartlocations.html',
      target: Hafas('#HFS_SmartLocationChangeIcon', false),
      template: 'SmartLocations_TplIconChangeBtn',
      model: {
        loc: loc
      }
    }, Hafas.bind(function (html) {
    }, this));
  }, _me));

  // Sets the disabled attribute of the smart location save button
  Hafas.ps.sub('/favorites/smartLocations/setSaveBtnDisabled', Hafas.bind(function (disabledVal) {
    // Remove disable state on save button
    var saveBtn = Hafas('#HFS_smartLocationSaveBtn');
    if (saveBtn) {
      if (disabledVal === true) {
        saveBtn.setAttribute("disabled", true);
      } else {
        saveBtn.removeAttribute("disabled");
      }
    }
  }, _me));

  // Sets the disabled attribute of the smart location remove button
  Hafas.ps.sub('/favorites/smartLocations/setRemoveBtnDisabled', Hafas.bind(function (disabledVal) {
    // Remove disable state on save button
    var removeBtn = Hafas('#HFS_smartLocationRemoveBtn');
    if (removeBtn) {
      if (disabledVal === true) {
        removeBtn.setAttribute("disabled", true);
      } else {
        removeBtn.removeAttribute("disabled");
      }
    }
  }, _me));

  // Shows an overlay as a warning for deleting the favorite
  Hafas.ps.sub('/favorites/smartLocations/removeFavoritePopup', Hafas.bind(function (locKey) {
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    // Create the remove favorite popup
    this.Controller.Favorites.instance.smartLocationRemoveOverlay = Hafas.Core.newType("HafasOverlay", {
      app: this,
      outputHTML: Hafas.Modules.Render.renderTemplate("SmartLocations_TplRemovePopup", {loc: location}),
      title: Hafas.Modules.i18n.get('Favorites.SmartLocations.t_N_deleteFavorite'),
      cssClass: 'lyr_smartLocationRemoveOverlay',
      onClose: function () {
      }
    });
  }, _me));

  // Shows an overlay as a warning for deleting the favorite
  Hafas.ps.sub('/favorites/smartLocations/removeFavorite', Hafas.bind(function (locKey) {
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    // Update the location in the favorites; Searches the location in favorites based on lid
    this.Controller.Favorites.instance.updateLocation(location, "");
    // Publish that the location has been updated
    Hafas.ps.pub('/favorites/smartLocations/locationUpdated', [location]);
    // Navigate back to the last view
    Hafas.ps.pub('/GUI/common/back', []);
  }, _me));

  // Accepts removing the smart location favorite
  Hafas.ps.sub('/favorites/smartLocations/removeFavoriteConfirmed', Hafas.bind(function (locKey) {
    var loc = Hafas.Modules.Render.objectKeeper.get(locKey);

    // Close icon popup
    Hafas.ps.pub('/favorites/smartLocations/closeRemovePopup', []);

    // Delete the whole location instead of moving to the history to have the same functionality as other "delete" buttons, e.g. in popovers
    loc.id = Hafas.Modules.Favorites.getInstances()[0].getLocationIndex(loc); // Needed in /favorites/removeFavToHistory
    Hafas.ps.pub('/favorites/deleteEntry', [{lid: loc.lid, storage: 'locations'}]);

    // Navigates back to close the edit view
    Hafas.ps.pub('/GUI/common/back', []);
  }, _me));

  // Saves the changes made to the smart location into the favorites
  Hafas.ps.sub('/favorites/smartLocations/saveChanges', Hafas.bind(function (params) {
    var location = Hafas.Modules.Render.objectKeeper.get(params.locKey);

    if (params.type === "add") {
      if (location.smartLocation !== undefined && location.smartLocation.isQuickFavorite === true) {
        // If it is a quickFavorite that we add, add it to the right of the quickFavorites list. Means: Search the last
        // quickFavorite inside the favorites list and add it after that
        var data = this.Controller.Favorites.instance.getData();
        var lastQuickFavIndex = 0;
        for (var i = 0; i < data.locations.length; i++) {
          var fav = data.locations[i];
          if (fav.smartLocation !== undefined && fav.smartLocation.isQuickFavorite === true) {
            lastQuickFavIndex = i+1; // +1 to be able to add after that element
          }
        }
        console.log(data);
      }
      // Add the location to favorites: It might be created via quickFavorites plus button or AddFavorite button in popover
      this.Controller.Favorites.instance.addLocation(location, "", false, true, lastQuickFavIndex);
      // Update the location in the favorites to take over smartLocation information in case it was missed in addLocation
      this.Controller.Favorites.instance.updateLocation(location, "");
    } else {
      // Update the location in the favorites; Searches the location in favorites based on lid
      this.Controller.Favorites.instance.updateLocation(location, "");
    }

    // Publish that the location has been updated
    Hafas.ps.pub('/favorites/smartLocations/locationUpdated', [location]);
    // Navigate back to the last view
    Hafas.ps.pub('/GUI/common/back', []);
  }, _me));

  // Marks a value as changed and handles the save button disabled state
  Hafas.ps.sub('/favorites/smartLocations/valueHasChanged', Hafas.bind(function (params) {
    params = params || {};
    var originalLocation = this.Controller.Favorites.instance.smartLocationEditModel.originalLocation;
    var modifyLocation = this.Controller.Favorites.instance.smartLocationEditModel.loc;
    var valuesChanged = false;
    var originalLocationKeysLength = Object.keys(originalLocation).length;
    var modifySmartLocationKeysLength = Object.keys(modifyLocation.smartLocation).length;
    var originalSmartLocationKeysLength = Object.keys(originalLocation.smartLocation).length;

    // Delete info if we haven't any smart location information left
    if (modifySmartLocationKeysLength === 0) {
      delete modifyLocation.smartLocation;
    }

    if (params.force !== undefined) {
      valuesChanged = params.force;
    } else if (modifySmartLocationKeysLength === 0 && originalSmartLocationKeysLength === 0 || originalLocationKeysLength === 0) {
      // Both smart location infos are empty or the original location doesn't exist in the first place
      valuesChanged = false;
    } else {
      // Check if the keys from modifyLocation are like the original values
      // Does not work for objects inside the smart locations (not needed yet)
      Object.keys(modifyLocation.smartLocation).forEach(function(propertyName, index) {
        // Get the values, we need a default of "" to be able to stringify if smartLocation is not defined on the objects
        var changedVal = "";
        if (modifyLocation.smartLocation && modifyLocation.smartLocation[propertyName]) {
          changedVal = modifyLocation.smartLocation[propertyName];
        }
        var originalVal = "";
        if (originalLocation.smartLocation && originalLocation.smartLocation[propertyName]) {
          originalVal = originalLocation.smartLocation[propertyName];
        }
        // Compare the values
        if (JSON.stringify(changedVal) !== JSON.stringify(originalVal)) {
          valuesChanged = true;
        }
      });
      // Check if there are values in the original that don't exist in the modifyLocation.smartLocation
      Object.keys(originalLocation.smartLocation).forEach(function(propertyName, index) {
        // No need to check the value behind that property as we done it in the loop before
        // If original had a property but the modifyLocation now has no smartLocation attribute at all or the
        // property is not existing, the value has changed
        if (modifyLocation.smartLocation === undefined || modifyLocation.smartLocation[propertyName] == null) {
          valuesChanged = true;
        }
      });
    }

    // Important for warning the user when he navigates back via actionbar
    this.Controller.Favorites.instance.smartLocationEditModel.valuesChanged = valuesChanged;

    // Set the disabled state of the save button
    if (valuesChanged) {
      Hafas.ps.pub('/favorites/smartLocations/setSaveBtnDisabled', [false]);
    } else {
      Hafas.ps.pub('/favorites/smartLocations/setSaveBtnDisabled', [true]);
    }
  }, _me));

  // If location was changed, show a warning before navigating back
  Hafas.ps.sub('/favorites/smartLocations/back', Hafas.bind(function (params) {
    var valuesChanged = this.Controller.Favorites.instance.smartLocationEditModel.valuesChanged;

    if (valuesChanged) {
      // Create the discard popup
      this.Controller.Favorites.instance.smartLocationDiscardOverlay = Hafas.Core.newType("HafasOverlay", {
        app: this,
        outputHTML: Hafas.Modules.Render.renderTemplate("SmartLocations_TplDiscardPopup", {}),
        title: "",
        cssClass: 'lyr_smartLocationDiscardOverlay',
        onClose: function () {
        }
      });
    } else {
      Hafas.ps.pub('/GUI/common/back', []);
    }
  }, _me));

  // Closes the discard changes popup when navigating back from an unsaved smart location
  Hafas.ps.sub('/favorites/smartLocations/closeDiscardPopup', Hafas.bind(function () {
    // Close icon popup
    if (this.Controller.Favorites.instance && this.Controller.Favorites.instance.smartLocationDiscardOverlay) {
      this.Controller.Favorites.instance.smartLocationDiscardOverlay.close();
    }
  }, _me));

  // Closes the remove favorite popup
  Hafas.ps.sub('/favorites/smartLocations/closeRemovePopup', Hafas.bind(function () {
    // Close icon popup
    if (this.Controller.Favorites.instance && this.Controller.Favorites.instance.smartLocationRemoveOverlay) {
      this.Controller.Favorites.instance.smartLocationRemoveOverlay.close();
    }
  }, _me));
};

HafasWebapp.prototype.subscriptions.debug = function (_me) {
  // Debug-Events --------------------------------------------------------------------------------------------------
  Hafas.ps.sub('/debug/a11y', Hafas.bind(_me.Controller.Debug.a11y, _me));
};
